<template>
    <div class="w-full">
        <HeadlessPopover v-slot="{ open, close }" class="relative">
            <HeadlessPopoverButton
                as="div"
                @mouseenter="handleMouseEnter($event, open)"
                @mouseleave="handleMouseLeave($event, open, close)"
                class="outline-none"
                :id="($attrs.id as string)"
            >
                <slot name="button" v-bind:open="open" />
            </HeadlessPopoverButton>

            <transition
                enter-active-class="transition duration-200 ease-out"
                enter-from-class="translate-y-1 opacity-0"
                enter-to-class="translate-y-0 opacity-100"
                leave-active-class="transition duration-150 ease-in"
                leave-from-class="translate-y-0 opacity-100"
                leave-to-class="translate-y-1 opacity-0"
            >
                <HeadlessPopoverPanel
                    @mouseleave="handleMenuItemsMouseLeave(close)"
                    @mouseenter="handleMenuItemsMouseEnter"
                    class="absolute top-10 z-50"
                    :class="parentClass"
                >
                    <slot name="content" v-bind:close="close" />
                </HeadlessPopoverPanel>
            </transition>
        </HeadlessPopover>
    </div>
</template>

<script setup lang="ts">
// * interfaces
interface IPopoverProps {
    parentClass?: string;
}

// * composables
const { handleMenuItemsMouseEnter, handleMenuItemsMouseLeave, handleMouseEnter, handleMouseLeave } =
    useDropDownHandler();

// * props
defineProps<IPopoverProps>();
</script>
